import className from 'classnames/bind';
import style from './Auth.module.scss';
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {notification} from "antd";
import {AuthLoginForm} from "~/features/Auth/components";
import {authErrorSelector, authLoadingSelector} from "~/features/Auth/authSlice";
import {Loading} from "~/components";
import utilitiesApi from "~/api/utilitiesApi";
import {apiError, handleRequest} from "~/utils";
import {globalNavigate} from "~/routes/GlobalHistory";

const cn = className.bind(style);

function Login() {
    const error   = useSelector(authErrorSelector);
    const loading = useSelector(authLoadingSelector);

    const [loadRanks, setLoadRanks] = useState(false);
    const [ranks, setRanks] = useState({
        top1: { name: '', avatar: '' },
        top2: { name: '', avatar: '' },
        top3: { name: '', avatar: '' },
    });

    useEffect(() => {
        async function fetchData() {
            setLoadRanks(true);
            let [err, response] = await handleRequest(utilitiesApi.ranks());
            let message = apiError(`Lấy bảng xếp hạng thất bại`, err, response);
            if (!message) {
                setRanks({
                    top1: { name: response.data[0]?.lastname || '', avatar: response.data[0]?.avatar || '' },
                    top2: { name: response.data[1]?.lastname || '', avatar: response.data[1]?.avatar || '' },
                    top3: { name: response.data[2]?.lastname || '', avatar: response.data[2]?.avatar || '' },
                });
            }
            setLoadRanks(false);
        }
        fetchData().then();
    }, []);

    if (error) {
        notification.error({ message: 'Thất bại', description: error });
    }

    if (Boolean(localStorage.getItem('access_token'))) {
        globalNavigate("/");
    }

    return (
        <div className={cn('login')}>
            {/* Background layers */}
            <div className={cn('stars')}/>
            <div className={cn('gridOverlay')}/>
            <div className={cn('orbMid')}/>
            <div className={cn('particles')}>
                <span/><span/><span/><span/><span/><span/>
                <span/><span/><span/><span/><span/><span/>
            </div>

            <div className={cn('loginWrapper')}>

                {/* LEFT – BẢNG XẾP HẠNG */}
                <div className={cn('loginInfo')}>
                    <div className={cn('ranksContainer')}>
                        <div className={cn('ranksHeader')}>
                            <span className={cn('trophyIcon')}>🏆</span>
                            <h2>Bảng xếp hạng</h2>
                            <p>Doanh thu cao nhất tháng trước</p>
                        </div>
                        {/* Thứ tự: 2 – 1 – 3 để tạo hiệu ứng podium */}
                        <div className={cn('loginRanks')}>

                            {/* TOP 2 */}
                            <div className={cn('rankCol', 'rank2')}>
                                <div className={cn('rankAvatar')}>
                                    <div className={cn('avatarRing')}>
                                        <div className={cn('avatarInner')}>
                                            {ranks.top2.avatar
                                                ? <img src={ranks.top2.avatar} alt={ranks.top2.name}/>
                                                : <span className={cn('avatarFallback')}>👤</span>
                                            }
                                        </div>
                                    </div>
                                    <div className={cn('rankMedal')}>🥈</div>
                                </div>
                                <div className={cn('columns')}>
                                    <div className={cn('txtTop')}>Top <span>2</span></div>
                                    <div className={cn('txtName')}>{ranks.top2.name || '---'}</div>
                                </div>
                            </div>

                            {/* TOP 1 */}
                            <div className={cn('rankCol', 'rank1')}>
                                <div className={cn('rankAvatar')}>
                                    <div className={cn('crownIcon')}>👑</div>
                                    <div className={cn('avatarRing')}>
                                        <div className={cn('avatarInner')}>
                                            {ranks.top1.avatar
                                                ? <img src={ranks.top1.avatar} alt={ranks.top1.name}/>
                                                : <span className={cn('avatarFallback')}>👤</span>
                                            }
                                        </div>
                                    </div>
                                    <div className={cn('rankMedal')}>🥇</div>
                                </div>
                                <div className={cn('columns')}>
                                    <div className={cn('txtTop')}>Top <span>1</span></div>
                                    <div className={cn('txtName')}>{ranks.top1.name || '---'}</div>
                                </div>
                            </div>

                            {/* TOP 3 */}
                            <div className={cn('rankCol', 'rank3')}>
                                <div className={cn('rankAvatar')}>
                                    <div className={cn('avatarRing')}>
                                        <div className={cn('avatarInner')}>
                                            {ranks.top3.avatar
                                                ? <img src={ranks.top3.avatar} alt={ranks.top3.name}/>
                                                : <span className={cn('avatarFallback')}>👤</span>
                                            }
                                        </div>
                                    </div>
                                    <div className={cn('rankMedal')}>🥉</div>
                                </div>
                                <div className={cn('columns')}>
                                    <div className={cn('txtTop')}>Top <span>3</span></div>
                                    <div className={cn('txtName')}>{ranks.top3.name || '---'}</div>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* HỆ SINH THÁI */}
                    <div className={cn('ecosystem')}>
                        <div className={cn('ecosystemTitle')}>
                            <span className={cn('ecosystemIcon')}>🌐</span>
                            Hệ sinh thái Sikido
                        </div>
                        <div className={cn('ecosystemGrid')}>
                            {[
                                { name: 'Sikido',     logo: 'https://sikido.vn/uploads/source/sikido.png',                          url: 'https://sikido.vn' },
                                { name: 'D&H',        logo: 'https://web40.vn/uploads/source//logo/logo-1.png',                      url: 'https://web40.vn' },
                                { name: 'Sikido ADS', logo: 'https://ads.sikido.vn/uploads/source/logo/logo-sikido-ads.jpg',         url: 'https://ads.sikido.vn' },
                                { name: 'Top 3',      logo: 'https://top3.vn/uploads/source//header/top3logo.png',                   url: 'https://top3.vn' },
                            ].map((item) => (
                                <a
                                    key={item.name}
                                    href={item.url}
                                    target="_blank"
                                    rel="noreferrer"
                                    className={cn('ecosystemCard')}
                                    title={item.name}
                                >
                                    <img src={item.logo} alt={item.name}/>
                                    <span>{item.name}</span>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>

                {/* RIGHT – FORM ĐĂNG NHẬP */}
                <div className={cn('loginForm')}>
                    {(loading || loadRanks) && <Loading/>}

                    <div className={cn('companyName')}>
                        <span className={cn('subTitle')}>Công ty TNHH</span>
                        <strong className={cn('mainTitle')}>SKD GROUP</strong>
                        <span className={cn('divider')}/>
                    </div>

                    <AuthLoginForm/>
                </div>

            </div>
        </div>
    );
}

export default Login;